<template>
  <Select
    :items="items"
    :selectedItem="selectedItem"
    :label="$i18n('interface.novo_filtro.custo')"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_custo')"
    :filtro_id="filtro.filtro"
    :id="filtro.filtro"
    :path="path"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { computed, toRef } from 'vue';
import Select from '../../components/Select.vue';
import { useFiltroSelect } from '../../composables/useFiltroSelect';

export default {
  components: { Select },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const items = computed(() => {
      const lista = props.filtro?.parametros?.items || [];
      return lista.map(item => ({ id: item.id, name: item.name }));
    });
    const { selectedItem, onAtualizar } = useFiltroSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
      items,
    });
    return { items, selectedItem, onAtualizar };
  },
}
</script>
